module.exports = __webpack_public_path__ + "static/img/rd-pawnshop-flag-icon.fa464092.png";